import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Quiz from '../../entities/cems/quiz'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface QuizState extends ListState<Quiz>{
    editModel: Quiz;
    reportList: Array<any>;
    cobertura: Array<any>;
    postventa: Array<any>;  
    ranking: Array<any>;  
}
class QuizModule extends ListModule<QuizState,any,Quiz>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Quiz>(),
        loading:false,
        editModel: new Quiz(),
        activeList: new Array<Quiz>(),
        cobertura: new Array<any>(),
        postventa: new Array<any>(),
        ranking: new Array<any>(),
        path: 'quizzes'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
         async getTableStats(context: ActionContext<QuizState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/table-stats', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.cobertura = reponse.data.result.cobertura;
            context.state.postventa = reponse.data.result.postventa;
            context.state.ranking = reponse.data.result.ranking;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: QuizState, model: Quiz) {
            state.editModel = model;
            state.editModel.responses.forEach((item,k) => {
                state.editModel.responses[k].question = Util.abp.list.getItem(item.question_id);
            }); 
        },
        view(state: QuizState, model: Quiz) {
            state.editModel = model;
            state.editModel.responses.forEach((item, k) => {
                state.editModel.responses[k].question = Util.abp.list.getItem(item.question_id);
            });

            console.log(state.editModel.responses);
        },
        new(state: QuizState, model: Quiz) {
            state.editModel = Object.assign({});
        },
    });
}
const quizModule=new QuizModule();
export default quizModule;
